__turbopack_context__.v({
  "navMenuLink": "NavMenuLink-module__fhQdfa__navMenuLink",
});
